// extracted by mini-css-extract-plugin
export default {"notaryStatesWrapper":"tYoj5W0R0qvNDZDUXotE","toggle":"Wbd0tQbREl7QHDngL8FG"};